import { observer } from "mobx-react";
import React from "react";
import { Auth } from "./Auth";
import { GlobalContext } from "../GlobalContext";
import { action, observable } from "mobx";
import { LoginBox } from "./LoginBox";
import { Link } from "react-router-dom";
import { SimpleFormView } from "../core/views/UForm";
import { UFormField } from "../core/views/UFormField";
import Box from "@mui/material/Box";
import { Button } from "../core/views/Button";
import { FormFields } from "../core/api/contracts/FormFields";

@observer
export class ForgotPasswordView extends React.Component<{ auth?: Auth }> {
  static contextType = GlobalContext;
  context!: React.ContextType<typeof GlobalContext>;
  @observable _loading: boolean;
  @observable _done: boolean;

  _formConfig = new FormFields()
    .addField("email", "required|email", "Email", "text", null, null, null, true)
    .createForm();

  @action.bound _submit(values: { email: string }) {
    this._loading = true;

    this.context.auth.forgotPassword(values.email).then(
      action(() => {
        this._loading = false;
        this._done = true;
      })
    );
  }

  render() {
    return (
      <LoginBox
        footer={
          <p>
            You remember your password?{" "}
            <Link to="/login" data-automation-name="login">
              Log In
            </Link>
          </p>
        }
      >
        <h1>Forgot Password</h1>

        <div className="create-feature-form">
          <p>Please insert the mail address which you used to sign up to Upsolver Streams.</p>

          {this._done ? (
            <p>
              If the mail address you supplied is valid, You should receive a mail with instructions on how to reset
              your password within the next 5 minutes. The mail will be valid for 24 hours.
            </p>
          ) : (
            <SimpleFormView form={this._formConfig} onSuccess={this._submit} disabled={this._loading}>
              <div className="form-input-group">
                <UFormField input={this._formConfig.$("email")} />
              </div>
              <Box width="100%" textAlign="center" mt={3}>
                <Button type="submit">Confirm</Button>
              </Box>
            </SimpleFormView>
          )}
        </div>
      </LoginBox>
    );
  }
}
